<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-user-operators></table-system-user-operators>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemUserOperators from './TableGrids/TableSystemUserOperators.vue'


export default {
    name: 'BizPartnerOperators',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemUserOperators
    },
    data() {
        return {
            page: {
                title: "Operators",
            },
            breadcrumbs: [
                { text: "Operators", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
